import { ORDERS_ENDPOINT } from 'modules/orders/constants/index.cjs'
import { API_METHOD } from 'modules/api/constants'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import { saveLegacyReduxAction } from 'modules/redux/actions/legacy/save'

/**
 * Gets the shipping for the order matching the given `id`.
 * @param  {Instance} instance
 * @returns {Function}
 */
function getShippingLabelOrderAction (instance) {
  return saveLegacyReduxAction({
    endpoint: ORDERS_ENDPOINT.GET_SHIPPING_LABEL,
    method: API_METHOD.POST,
    path: getPathReduxUtil(instance),
    data: {
      id: getIdReduxUtil(instance)
    }
  })
}

export {
  getShippingLabelOrderAction
}
